<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container" v-loading="loading">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true">

                        </ReturnNavBar>
                        <div class="mobile_head_operate" >
                            <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                                <ul class="head_operate_popover_list">
                                    <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                                        <i :class="item.icon"></i> <span v-text="item.text"></span>
                                    </li>
                                </ul>
                                <template #reference>
                                    <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                    <div class="inventory_management_container mobile_container">
                        <div class="inventory_in_out">
                            <ul>
                                <li style="background:#E0F7D5 url('https://download.hecoos.com/enlightv/2025-01/82dd532ba31ac59f253028a9cf344a4e.png') bottom right no-repeat">
                                    <h5>入库（{{summaryData.in.today}}笔）</h5>
                                    <p>较昨日</p>
                                    <div>
                                        <i class="iconfont icon-shangsheng" v-if="summaryData.in.change > 0"></i>
                                        <i class="iconfont icon-xiajiang" v-else></i><span v-if="summaryData.in.change != ''">{{summaryData.in.change}}笔</span>
                                    </div>
                                </li>
                                <li style="background:#FAEFD9 url('https://download.hecoos.com/enlightv/2025-01/7e7d0830755eebdb1de829d199f32828.png') bottom right no-repeat">
                                    <h5>出库（{{summaryData.out.today}}笔）</h5>
                                    <p>较昨日</p>
                                    <div>
                                        <i class="iconfont icon-shangsheng" v-if="summaryData.out.change > 0"></i>
                                        <i class="iconfont icon-xiajiang" v-else></i><span v-if="summaryData.out.change != ''">{{summaryData.out.change}}笔</span>
                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div class="inventory_in_out_hot_ranking">
                            <div class="top">
                               <div @click="tabRadioPicker = true">
                                   <span class="blod" v-text="hotTabList.find(find =>find.value == hotTabActive).name"></span>
                                   <i class="el-icon-caret-bottom"></i>
                               </div>
                                <div @click="timeRadioPicker = true">
                                    <span v-text="hotTimeList.find(find =>find.value == hotTimeActive).name">今日</span>
                                    <i class="el-icon-arrow-down"></i>
                                </div>
                            </div>
                            <div class="bottom ">
                                <ul v-if="hotDataList.length>0">
                                    <li v-for="(item,key) in hotDataList" :key="key">
                                        <i v-if="key == 0"><img alt="" src="https://download.hecoos.com/enlightv/2024-35/prskRsnEHh8YMPpjWAn8.svg"></i>
                                        <i v-else-if="key == 1"><img alt="" src="https://download.hecoos.com/enlightv/2024-35/bwDetKhFJmkw3n4sc7Df.svg"></i>
                                        <i v-else-if="key == 2"><img alt="" src="https://download.hecoos.com/enlightv/2024-35/H3iEikZ6bmX6eNM5Gh5m.svg"></i>
                                        <i v-else>{{key+1}}</i>
                                        <p class="ellipsis">{{item.name}}</p>
                                        <span>{{item.total_quantity}}{{item.unit}}</span>
                                    </li>
                                </ul>
                                <img v-else src="https://download.hecoos.com/enlightv/2025-09/c59611d310cc1817cc597f645c1221a2.png" alt="">
                            </div>
                        </div>

                        <div class="inventory_in_out_audit">
                            <div class="top">
                                <span :class="activeType == 'in' ? 'active' : ''" @click="handleClickAudit('in')">待入库（{{paddingInTotal}}）</span>
                                <span :class="activeType == 'out' ? 'active' : ''" @click="handleClickAudit('out')">待出库（{{paddingOutTotal}}）</span>
                            </div>
                            <div class="bottom">
                                <ul v-if="activeType == 'in'" v-infinite-scroll="onLoadList">
                                    <li v-for="item in pendingList">
                                        <div class="mobile_head_user" v-if="item.creator_info && item.creator_info.id"  @click="handleClickUserDetail(item.creator_info.id)">
                                            <img :src="item.creator_info.avatar" alt="">
                                            <span class="ellipsis" v-text="item.creator_info.name"></span>
                                        </div>
                                        <div class="right">
                                            <p class="ellipsis" v-text="item.approval_set_name ? item.approval_set_name : ''"></p>
                                            <div class="btn_container">
                                                <van-button @click="handleClickInAudit(item)" size="mini" plain color="#2990F0">入库</van-button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <img class="no_data" v-if="activeType == 'in' && pendingList.length == 0" src="https://download.hecoos.com/enlightv/2025-09/c59611d310cc1817cc597f645c1221a2.png" alt="">
                                <ul v-if="activeType == 'out'" v-infinite-scroll="onLoadList">
                                    <li v-for="item in pendingList">
                                        <div class="mobile_head_user" v-if="item.creator_info && item.creator_info.id"  @click="handleClickUserDetail(item.creator_info.id)">
                                            <img :src="item.creator_info.avatar" alt="">
                                            <span class="ellipsis" v-text="item.creator_info.name"></span>
                                        </div>
                                        <div class="right">
                                            <p class="ellipsis" v-text="item.approval_set_name ? item.approval_set_name : ''"></p>
                                            <div class="btn_container">
                                               <van-button @click="handleClickOutAudit(item)" size="mini" plain color="#2990F0">出库</van-button>
                                            </div>
                                        </div>

                                    </li>
                                </ul>
                                <img class="no_data" v-if="activeType == 'out' && pendingList.length == 0" src="https://download.hecoos.com/enlightv/2025-09/c59611d310cc1817cc597f645c1221a2.png" alt="">
                            </div>
                        </div>

                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>


                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"  v-if="tabRadioPicker" :show="tabRadioPicker" @click="tabRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in hotTabList" class="radio_option_item"  @click="handleClickHotTabItem(item)"  v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="tabRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>

                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"  v-if="timeRadioPicker" :show="timeRadioPicker" @click="timeRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in hotTimeList" class="radio_option_item"  @click="handleClickHotTimeItem(item)"  v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="timeRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>

                    <userDetailDialog
                            v-if="userDetailPopupShow"
                            :userDetailPopupShow.sync="userDetailPopupShow"
                            :userId="userDetailId"
                    />
                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import {stockSummary,stockTopProducts,stockPendingInList,stockPendingOutList,getPendingList,pendingNum} from "@/api"
import {getDateRange} from "@/utils"
import PullContainer from '@/components/mComponents/PullContainer.vue'
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from '@/components/mComponents/FooterTabbar.vue'
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import {pagination} from '@/mixins'
export default {
    name: 'inventoryManagement',
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        userDetailDialog
    },
    data () {
        return {
            loading:false,
            tabBarList:[
                {
                    icon:'icon-shouye',
                    activeIcon:'icon-shouyexuanzhong',
                    routerName:'InventoryManagement',
                    title:'首页'
                },
                {
                    icon:'icon-cangku2',
                    activeIcon:'icon-cangkuxuanzhong',
                    routerName:'WarehouseManagement',
                    title:'仓库管理'
                },
                {
                    icon:'icon-renwu_weixuanzhong',
                    activeIcon:'icon-renwu_xuanzhong',
                    routerName:'InventoryPending',
                    title:'出入库待办'
                },

            ],
            tabBarActive:0,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:'out', text: "出库", icon: "iconfont icon-chuku" },
                {value:'in', text: "入库", icon: "iconfont icon-ruku" },
                {value:'scan', text: "扫一扫", icon: "iconfont icon-saoyisao" },
            ],
            hotTabList:[
                {name:'出库热门产品排行',value:'out'},
                {name:'入库热门产品排行',value:'in'},
            ],
            tabRadioPicker:false,
            hotTabActive:'in',
            hotTimeList:[
                {name:'今天',value:'today'},
                {name:'昨天',value:'yesterday'},
                {name:'本周',value:'week'},
                {name:'上周',value:'last_week'},
                {name:'本月',value:'month'},
                {name:'上月',value:'last_month'},
                {name:'今年',value:'year'},
            ],
            hotTimeActive:'today',
            hotTime:getDateRange('today'),
            timeRadioPicker:false,
            activeType:'in',

            summaryData:{
                in:{
                    change: '0',
                    today: '0',
                    yesterday: '0'
                },
                out:{
                    change: '0',
                    today: '0',
                    yesterday: '0'
                }
            },
            hotDataList:[],

            pendingList:[],
            paddingInTotal:0,
            paddingOutTotal:0,
            userDetailPopupShow:false,
            userDetailId: 0,

        }
    },
    mixins: [pagination],
    created() {
        this.initData()
    },
    mounted () {

    },
    methods: {
        pullDownLoadingSuccess(flag){
            if(flag){
                if (flag) {
                    this.pullDownLoading = true
                    this.initData()
                }
            }
        },
        initData(){
            this.getPendingNum()
            this.getStockSummary()
            this.getStockTopProducts()
            this.handleClickAudit(this.activeType)
        },
        handleClickHeadOperate(item) {
            if(item.value == 'in'){
                this.handleInWarehouseAdd()
            }else if(item.value == 'out'){
                this.handleOutWarehouseAdd()
            }else{

            }
            this.headOperatePopoverShow = false;
        },

        // 普通入库
        handleInWarehouseAdd(data){
            this.$router.push({
                name:'InWarehouseAdd',
                params:{data:data}
            })
        },
        // 普通出库
        handleOutWarehouseAdd(data){
            this.$router.push({
                name:'OutWarehouseAdd',
                params:{data:data}
            })
        },
        // 选择排行日期
        handleClickHotTimeItem(item){
            this.hotTimeActive = item.value
            this.hotTime = getDateRange(item.value)
            this.timeRadioPicker = false
            this.getStockTopProducts()
        },
        // 选择排行类型
        handleClickHotTabItem(item){
            this.hotTabActive = item.value
            this.tabRadioPicker = false
            this.getStockTopProducts()
        },
        // 切换待办类型
        handleClickAudit(type){
          this.activeType = type
          this.pagination.pageNum = 1
          this.pendingList = []
          this.getPendingList()
        },
        // 移动端库存首页统计
        getStockSummary(){
            stockSummary().then(res => {
                if (res.code === 200) {
                    this.summaryData = res.data
                    this.getStockTopProducts()
                }
            })
        },
        // 获取热门库存排行
        getStockTopProducts(){
            let postData = {
                type:this.hotTabActive,
                date_range:this.hotTime,
                pageSize:10
            }
            stockTopProducts(postData).then(res => {
                if (res.code === 200) {
                    this.hotDataList = res.data
                }
            })
        },
        // 获取出入库代办数量
        getPendingNum(){
            pendingNum().then(res => {
                if (res.code === 200) {
                    let {in_num,out_num} = res.data
                    this.paddingInTotal = in_num
                    this.paddingOutTotal = out_num
                }
            })
        },
        // 查看用户信息
        handleClickUserDetail(uid){
            this.userDetailId = uid
            this.userDetailPopupShow = true
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total ==  this.pendingList.length){
                return false
            }
            if(this.loading == false){
                this.getPendingList()
            }
        },

        // 获取库存待办
        getPendingList(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize:this.pagination.pageSize,
                type:this.activeType,
                sort:'desc'
            }
            getPendingList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    this.pendingList = this.pendingList.concat(list)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                    this.loading = false
                    if(this.pullDownLoading){
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                    }
                }
            })
        },

        // 审核入库
        handleClickInAudit(item){
            this.$router.push({
                name: 'InWarehouseAudit',
                query:{
                    stock_pending_id:item.stock_pending_id,
                    name:item.approval_set_name
                },
                params: {
                    isPush: true
                }
            })
        },

        // 审核出库
        handleClickOutAudit(item){
            this.$router.push({
                name: 'OutWarehouseAudit',
                query:{
                    stock_pending_id:item.stock_pending_id,
                    name:item.approval_set_name
                },
                params: {
                    isPush: true
                }
            })
        },


    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/inventory_management.scss";
</style>
